module.exports = __webpack_public_path__ + "img/orangeCat.d9d11910.svg";